/**
 * Marketing HTML sanitizer.
 *
 * Source of the HTML we feed in is `/public/site/index.html` and
 * `/public/site/features.html` — both are static, repo-controlled assets. They
 * are NOT user-generated. DOMPurify here is defense-in-depth so any future
 * accidental introduction of dynamic content can't be exploited via XSS.
 *
 * We configure DOMPurify to keep:
 *   - inline <style> blocks (marketing layout depends on them)
 *   - SVG markup (icons, illustrations)
 *   - `style`, `class`, `data-*`, `aria-*`, `id`, `href`, `src`, `alt`,
 *     `viewBox`, `fill`, `stroke`, etc.
 *
 * We strip:
 *   - <script> tags
 *   - inline event handlers (onclick / onload / …)
 *   - `javascript:` URLs
 */
import DOMPurify from 'dompurify';

const COMMON_CONFIG = {
  USE_PROFILES: { html: true, svg: true, svgFilters: true },
  ADD_TAGS: ['style'],
  ADD_ATTR: ['target', 'rel'],
  // Allow style attribute (marketing layout uses inline styles in spots)
  ALLOWED_ATTR: undefined,
  FORBID_ATTR: ['onerror', 'onload', 'onclick', 'onmouseover', 'onmouseenter', 'onfocus', 'onblur'],
};

export function sanitizeMarketingHtml(dirty) {
  if (!dirty) return '';
  return DOMPurify.sanitize(dirty, COMMON_CONFIG);
}

export function sanitizeStyleBlock(css) {
  if (!css) return '';
  // CSS-only sanitization — strip any HTML, allow @import/@media/etc.
  return DOMPurify.sanitize(css, { ALLOWED_TAGS: [], ALLOWED_ATTR: [] });
}
